var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert",class:{ 'alert--text-bold': _vm.textBold }},[_c('v-icon',{attrs:{"size":"22"}},[_vm._v(" mdi-exclamation-thick ")]),_c('span',[_vm._v(_vm._s(_vm.$t("message.posts.planning.info", [_vm.type])))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }